import { useState, useEffect } from 'react';
  import { Box, Flex, IconButton, Button, Select } from
  '@chakra-ui/react';
  import { MdDelete, MdSearch, MdEdit } from 'react-icons/md';

  import Page from '../components/common/Page';
  import { ApiCommand } from '../lib/Api';
  import useToastNotification from
  '../lib/hooks/useToastNotification';
  import StrongTable from '../components/common/StrongTable';
  import StrongPagination from
  '../components/common/StrongPagination';
  import useApi from '../lib/hooks/useApi';
  import urlConstants from '../lib/constants/url.constants';
  import StrongInput from '../components/common/StrongInput';
  import EditHomeModal from '../components/homes/EditHomeModal';

  

  const {
    getHomes: getHomesUrl,
    createHome: createHomeUrl,
    editHome: editHomeUrl,
    deleteHome: deleteHomeUrl,
  } = urlConstants.homes;

  const Homes = () => {
    const [homes, setHomes] = useState<Home[]>([]);
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [totalPages, setTotalPages] = useState<number>(1);
    const [totalCount, setTotalCount] = useState<number>(0);
    const [pageSize, setPageSize] = useState<number>(10);
    const [isOpenModal, setIsOpenModal] =
  useState<boolean>(false);
    const [selectedHome, setSelectedHome] = useState<Home |
  undefined>();
    const [searchQuery, setSearchQuery] = useState<string>('');
    const [sortCriteria, setSortCriteria] =
  useState<string>('NewestAdded');
    const showToast = useToastNotification();

    const { loading: isGetLoading, sendRequest: getHomes } =
  useApi<GetHomesResponse>();
    const { sendRequest: createHome } = useApi<any>();
    const { sendRequest: editHome } = useApi<any>();
    const { sendRequest: deleteHome } = useApi<any>();

    const fetchHomes = () => {
      getHomes({
        callback: (data: GetHomesResponse | null, error: string 
  | null) => {
          if (error) { showToast({ title: 'Failed', description:
   error, status: 'error' }); return; }
          if (!data) return;
          setHomes(data.homes);
          setTotalPages(data.pagination.totalPages);
          setTotalCount(data.pagination.totalCount);
        },
        command: ApiCommand.GET,
        url: getHomesUrl,
        options: { page: currentPage, limit: pageSize, search:
  searchQuery, sortBy: sortCriteria },
      });
    };

    useEffect(() => { fetchHomes(); }, [currentPage, pageSize,
  searchQuery, sortCriteria]);

      
      const HOME_COLUMNS = [                         
    { key: 'title', label: 'Section' },
    {
      key: 'status',
      label: 'Status',
      render: (value: string, row: any) => (                            
        <input
          type="checkbox"                                               
          checked={value === 'active'}
          onChange={() => onToggleStatus(row)}   
        />
      ),                                                                
    },
    {                                                                   
      key: 'images',
      label: 'Images',                           
      render: (value: string[]) => `${value?.length || 0} image(s)`,
    },
  ];
    const onSaveHome = (title: string, images: File[], status:
  string) => {
      const formData = new FormData();
      formData.append('title', title);
      formData.append('status', status);
      images.forEach((img) => formData.append('images', img));

      if (selectedHome) {
        formData.append('homeId', selectedHome._id ||
  selectedHome.id || '');
        editHome({
          callback: (_data, error: string | null) => {
            if (error) { showToast({ title: 'Failed',description: error, status: 'error' }); return; }
            showToast({ title: 'Success', description: 'Home updated successfully', status: 'success' });
            setIsOpenModal(false);
            fetchHomes();
          },
          command: ApiCommand.PUT,
          url: editHomeUrl,
          options: formData,
        });
      } else {
        createHome({
          callback: (_data, error: string | null) => {
            if (error) { showToast({ title: 'Failed',description: error, status: 'error' }); return; }
            showToast({ title: 'Success', description: 'Home created successfully', status: 'success' });
            setIsOpenModal(false);
            fetchHomes();
          },
          command: ApiCommand.POST,
          url: createHomeUrl,
          options: formData,
        });
      }
    };

    const onDeleteHome = (homeId: string) => {
      deleteHome({
        callback: (_data, error: string | null) => {
          if (error) { showToast({ title: 'Failed', description: error, status: 'error' }); return; }
          showToast({ title: 'Success', description: 'Home deleted successfully', status: 'success' });
          fetchHomes();
        },
        command: ApiCommand.DELETE,
        url: deleteHomeUrl,
        options: { homeId },
      });
    };

        const onToggleStatus = (home: Home) => {                                
            const newStatus = home.status === 'active' ? 'inactive' : 'active';
            const formData = new FormData();                                    
            formData.append('homeId', home._id || home.id || '');
            formData.append('title', home.title);                               
            formData.append('status', newStatus);
            editHome({                                                          
            callback: (_data, error) => {                                     
                if (error) { showToast({ title: 'Failed', description: error,
        status: 'error' }); return; }                                         
                fetchHomes();
            },                                                                
            command: ApiCommand.PUT,
            url: editHomeUrl,                          
            options: formData,                                                
            });
    }; 
      
    return (
      <Page>
        <Flex flexDirection='column' height='full' 
  justifyContent='space-between'>
          <Box backgroundColor='white' borderRadius='lg' 
  padding={2}>
            <Flex justifyContent='space-between' 
  marginBottom={4}>
              <Box flex='1' maxW='400px'>
                <StrongInput
                  placeholder='Search'
                  rightIcon={<MdSearch color='gray.500' />}
                  value={searchQuery}
                  onChange={(e) =>
  setSearchQuery(e.target.value)}
                />
              </Box>
              <Select value={sortCriteria} onChange={(e) =>
  setSortCriteria(e.target.value)} width='20%'>
                <option value='NameAtoZ'>A-Z</option>
                <option value='NameZtoA'>Z-A</option>
                <option value='NewestAdded'>Newest</option>
                <option value='OldestAdded'>Oldest</option>
              </Select>
              <Button
                colorScheme='primary' px={6} py={4} 
  borderRadius='md' fontWeight='bold'
                _hover={{ bg: 'primary.300' }}
                onClick={() => { setSelectedHome(undefined);
  setIsOpenModal(true); }}
              >
                Create Home
              </Button>
            </Flex>
            <StrongTable
              columns={HOME_COLUMNS}
              data={homes}
              loading={isGetLoading}
              actions={(row) => (
                <>
                  <IconButton
                    aria-label='Edit' icon={<MdEdit />}
  variant='outline'
                    colorScheme='primary' size='sm'
  marginRight={4}
                    onClick={() => {
  setSelectedHome(homes.find((h) => (h._id || h.id) === (row._id
   || row.id))); setIsOpenModal(true); }}
                  />
                  <IconButton
                    aria-label='Delete' icon={<MdDelete />}
  variant='outline'
                    colorScheme='red' size='sm'
                    onClick={() => onDeleteHome(row._id ||
  row.id)}
                  />
                </>
              )}
            />
          </Box>
          <StrongPagination
            currentPage={currentPage} totalPages={totalPages}
            totalCount={totalCount} pageSize={pageSize}
            onPageChange={setCurrentPage}
            onPageSizeChange={(size) => { setPageSize(size);
  setCurrentPage(1); }}
          />
        </Flex>

        <EditHomeModal
          isOpen={isOpenModal}
          onClose={() => setIsOpenModal(false)}
          onSubmit={onSaveHome}
          selectedHome={selectedHome}
        />
      </Page>
    );
  };

  export default Homes;